enum TTimelineItemStatus {
  COMPLETED = 'COMPLETED',
  NOT_STARTED = 'NOT_STARTED',
  ACTIVE = 'ACTIVE',
}

type TTimelineItem = {
  id: string;
  text: string;
  status: TTimelineItemStatus;
  isCompleted: boolean;
  disabled?: boolean;
  isHidden?: boolean;
};

export { TTimelineItemStatus };
export type { TTimelineItem };
